<script lang="ts" setup>
import { IconChevronRightSmall } from '@cypress-design/vue-icon'
</script>

<template>
  <span class="relative ml-[6px] inline-block h-[16px] w-[16px]">
    <svg
      width="10"
      height="16"
      viewBox="0 0 10 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="ml-[4px] w-[2px] origin-right transition-all group-hover:w-[10px]"
      preserveAspectRatio="none"
    >
      <path d="M 1 8 L 9 8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
    <IconChevronRightSmall class="absolute left-[-4px] top-0 duration-150 group-hover:translate-x-[8px]" />
  </span>
</template>
